/**
 * Service: calendar
 */
angular.module('acme.common.service.calendar', [
  'acme.common.service.helpers',
  'acme.common.service.userPreferences'
])
.service('CalendarService', [ '$filter', 'HelpersService', 'UserPreferencesService', function($filter, HelpersService, UserPreferencesService) {

    var CalendarService = {

      current: {},
      preferences: UserPreferencesService,
      weekdays: {
        Su: { name: 'Sunday', number: 1 },
        M: { name: 'Monday', number: 2 },
        Tu: { name: 'Tuesday', number: 3 },
        W: { name: 'Wednesday', number: 4 },
        Th: { name: 'Thursday', number: 5 },
        F: { name: 'Friday', number: 6 },
        Sa: { name: 'Saturday', number: 7 }
      },

      /*
       * All values passed to logic filter must be of type Date
       *
       * Based on 4/17/2015
       *
       * Today - 4/17 - 4/17
       * Yesterday - 4/16 - 4/16
       * Last Week - 4/5 - 4/11
       * This Week - 4/12 (Sun) - 4/18 (Sat) (doesn't matter what today is)
       * Week to Date - 4/12 (Sun) - 4/17 (today at 23:59)
       * Last Month - 3/1 - 3/31
       * This Month - 4/1 - 4/30 (doesn't matter what today is)
       * Month to Date - 4/1 - 4/17 (today at 23:59)
       * Last Year - 01/01/2014 - 12/31/2014
       * This Year - 01/01/2015 - 12/31/2014 (doesn't matter what today is)
       * Year to Date - 01/01/2015 - 04/17 (today at 23:59)
       */
      ranges: [
        {
          label: 'Today',
          type: 'today',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'single');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'single');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Yesterday',
          type: 'yesterday',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'single');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'single');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Last Week',
          type: 'last_week',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end);
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() - 7, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() - 1, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'This Week',
          type: 'current_week',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay(), 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), (date.getDate() - date.getDay()) + 6, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Week to Date',
          type: 'week_to_date',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay(), 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Last Month',
          type: 'last_month',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), 0, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'This Month',
          type: 'current_month',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Month to Date',
          type: 'month_to_date',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Last Year',
          type: 'last_year',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear() - 1, 0, 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear() - 1, 11, 31, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'This Year',
          type: 'current_year',
          dates: '',
          startDate: '',
          endDate: '',

          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        },
        {
          label: 'Year to Date',
          type: 'ytd',
          dates: '',
          startDate: '',
          endDate: '',
          relabel: function(start, end) {
            CalendarService.setDates.call(this, start, end, 'double');
            this.label = this.label + ' - ' + this.dates;
          },

          logic: function(date) {
            var startDate = new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

            CalendarService.setDates.call(this, startDate, endDate, 'double');

            return {
              startDate: startDate,
              endDate: endDate
            };
          }
        }
      ],


      init: function() {
        return true;
      },
      
      setDates: function (startDate, endDate, type) {
        this.startDate = startDate instanceof Date ? startDate.toISOString() : startDate;
        this.endDate = endDate instanceof Date ? endDate.toISOString() : endDate;

        if (type === 'double'){
          this.dates = $filter('date')(startDate, CalendarService.preferences.getDateFormat('shortDate', 'dateFormat')) + ' to ' + $filter('date')(endDate, CalendarService.preferences.getDateFormat('shortDate', 'dateFormat'));
        } else if (type === 'single') {
          this.dates = $filter('date')(startDate, CalendarService.preferences.getDateFormat('shortDate', 'dateFormat'));
        }
      },

      create: function(eventData) {
        this.current = eventData;
      },

      getWeekdayShortName: function(longName) {

        var day;
        var r = false;

        for (day in this.weekdays) {
          if (this.weekdays.hasOwnProperty(day)) {
            if (this.weekdays[day].name.toLowerCase() === longName.toLowerCase()) {
              r = day;
              break;
            }
          }
        }

        return r;

      },

      getWeekdayArray: function(type) {
        var day;
        var r = [];

        for (day in this.weekdays) {
          if (this.weekdays.hasOwnProperty(day)) {
            switch(type) {
              case 'short':
                r.push(day);
                break;
              case 'number':
                r.push(this.weekdays[day].number);
                break;
              case 'long':
                r.push(this.weekdays[day].name);
                break;
              default:
                r.push(this.weekdays[day].name);
            }
          }
        }

        return r;
      },

      getWeek: function(date, returnText) {
        var r;
        var d = new Date(date);
        var week = parseInt(((d.getDate() - 1) / 7), 10) + 1;

        if (returnText) {
          switch (week) {
            case 1:
              r = "first";
              break;
            case 2:
              r = "second";
              break;
            case 3:
              r = "third";
              break;
            case 4:
              r = "fourth";
              break;
            case 5:
              r = "fifth";
              break;
          }
        }else{
          r = week;
        }

        return r;
      },

      parseDate: function(date) {

        var split;
        var d = date;

        if ( typeof(d) === 'string' ) {
          split = date.split(/[^0-9]/);
          d = new Date(split[0], split[1]-1, split[2], split[3], split[4], split[5]);
        }

        return d;
      },

      daysToString: function(days) {

        var i, ii;
        var m;
        var day;
        var wTest;
        var lastM;
        var matches;
        var r = [];
        var parts = [];
        var ordered = [];
        var weekdays = this.getWeekdayArray('short');
        var sOrdered;
        var sWeekdays = '';

        if (days instanceof Array) {
          for (i = 0, ii = days.length; i < ii; i++) {
            for (day in this.weekdays) {
              if (this.weekdays.hasOwnProperty(day) && days[i] === day) {
                ordered.splice(this.weekdays[day].number - 1, 0, days[i]);
                break;
              }
            }
          }

          sOrdered = ordered.join('');

          for (i = 0, ii = weekdays.length; i < ii; i++) {
            if (lastM) {
              sWeekdays += weekdays[i];
            } else {
              sWeekdays = weekdays[i];
            }

            wTest = new RegExp(sWeekdays);
            m = sOrdered.match(wTest);

            if (m) {
              lastM = m[0];
              if (i == ii - 1) {
                parts.push(m[0]);
              }
            } else {
              if (lastM) {
                parts.push(lastM);
                lastM = false;
              }
            }
          }

          for (i = 0, ii = parts.length; i < ii; i++) {
            matches = /^([ST]{1}[auh]{1}|[MTWF]{1})(.*?)([ST]{1}[auh]{1}|[MTWF]{1})$/g.exec(parts[i]);
            if (matches) {
              if (matches[2].length) {
                r.push(matches[1] + ' - ' + matches[3]);
              } else {
                r.push(matches[1]);
                r.push(matches[3]);
              }
            } else {
              r.push(parts[i]);
            }
          }

          if (r.length) {
            r = r.join(', ');
          }else{
            r = 'None';
          }

        }else{
          r = 'None';
        }

        return r;

      },

      toISO8601: function(date, fixZ) {
        var format = 'yyyy-MM-ddTHH:mm:ssZ';
        var r = $filter('date')(date, format);

        if (fixZ) {
          r = r.replace(/^(.*?)(\+|\-)([\d]{2})([\d]{2})$/, "$1$2$3:$4");
                          //1    2      3        4
        }

        return r;
      },

      toTZISO8601: function(date, timezone) {
        var format = 'yyyy-MM-ddTHH:mm:ss';
        var r = $filter('date')(date, format);

        if (timezone) {
          r += timezone;
        }

        return r;
      },

      /**
       * 
       * @param {Date | number | string} date 
       * @param {string} format 
       * @returns {string}
       */
      toFormat: function (date, format) {
        return $filter('date')(date, format);
      },

      toYMDDate: function(date) {
        var format = 'yyyy-MM-dd';

        return $filter('date')(date, format);
      },

      toMinutes: function(minute) {
        if (minute < 10) {
          return "0"+minute;
        }

        return minute;
      },

      toHour: function(hour) {
        var h = hour;

        if (h > 12) {
          h -= 12;
        }

        if (h === 0) {
          h = 12;
        }

        return h;
      },

      toHourHH: function(hour) {
        var h = hour;

        if (h < 10) {
          h = '0' + h;
        }

        if (h === 0) {
          h = '00';
        }

        return h;
      },

      timeToDurationString: function(time, showZeroMins) {

        var s = '';
        var h = (time.hour) ? this.toHour(time.hour) : 0;
        var m = (time.minutes) ? this.toMinutes(time.minutes) : '00';

        if (h) {
          s += h + ' hr';
        }

        if (m !== '00' || (showZeroMins && m === '00')) {
          s += ' ' + m + ' min';
        }

        return s;

      },

      durationToString: function(time, showZeroMins) {

        var s = '';
        var h = (time.hour) ? time.hour : 0;
        var m = (time.minutes) ? time.minutes : '00';

        if (h) {
          s += h + ' hr';
        }

        if (m !== '00' || (showZeroMins && m === '00')) {
          s += ' ' + m + ' min';
        }

        return s;

      },

      timeToString: function(time, format) {

        var h = (time.hour) ? this.toHour(time.hour) : '12';
        var m = (time.minutes) ? this.toMinutes(time.minutes) : '00';
        var r = h + ':' + m + ' ' + this.getMeridian(time.hour);

        if(format && format === 'HH:mm') {
          h = this.toHourHH(time.hour);
          r = h + ':' + m;
        } 

        return r;
      },

      timeToDate: function(time) {
        var r;
        var d = new Date();
        var ts = time.split(':');
        var h = +ts[0];
        var m = +ts[1].split(' ')[0];
        var mer = ts[1].split(' ')[1];

        if (mer && mer.toLowerCase() === 'pm' && h < 12) {
          h += 12;
        }else if ( mer && mer.toLowerCase() === 'am' && h === 12) {
          h = 0;
        }

        r = new Date(d.getFullYear(), d.getMonth(), d.getDate(), h, m, 0, 0);

        if (!(r instanceof Date) && !isNaN(r.valueOf())) {
          r = false;
        }

        return r;

      },

      dateRangeToDuration: function(startDate, endDate) {
        var diff = endDate.getTime() - startDate.getTime();
        var duration = { hour: 0, minutes: 0 };

        if (!diff && diff < 0) {
          diff = 0;
        }
        duration.hour = Math.floor(diff / 3600000);
        duration.minutes = Math.round(((diff % 86400000) % 3600000) / 60000);
        return duration;
      },

      timeToMilitary :function(time) {
        time = time.split(':');

        var hour = parseInt(time[0],10);
        var min = parseInt(time[1],10);
        var PM = time.match('PM') ? true : false;

        if (PM) {
          hour = 12 + hour;
          sec = time[2].replace('PM', '');
        } else {
          sec = time[2].replace('AM', '');
        }

        return (hour < 10 ? '0' + hour : hour) + ':' + (min < 10 ? '0' + min : min) + ':' + sec;
      },

      militaryTimeToDate: function(time) {
        var r;
        var d = new Date();
        var ts = time.split(':');
        var h = +ts[0];
        var m = +ts[1].split(' ')[0];

        r = new Date(d.getFullYear(), d.getMonth(), d.getDate(), h, m, 0);

        if (!(r instanceof Date) && !isNaN(r.valueOf())) {
          r = false;
        }

        return r;

      },

      getMeridian: function(hour, lower) {
        var m = (hour >= 12) ? 'PM' : 'AM';

        return (lower) ? m.toLowerCase() : m;
      },

      rangeToTime: function(range, isStandardTime) {
        var hours = range.split('-');
        var start = hours[0];
        var end = hours[1];
        var sHour = (isStandardTime) ? this.toHour(+start.split(':')[0]) : start.split(':')[0];
        var sMinutes = this.toMinutes(+start.split(':')[1]);
        var eHour = (isStandardTime) ? this.toHour(+end.split(':')[0]) : end.split(':')[0];
        var eMinutes = this.toMinutes(+end.split(':')[1]);
        var sMedirian = (isStandardTime) ? this.getMeridian(+start.split(':')[0]) : '';
        var eMedirian = (isStandardTime) ? this.getMeridian(+end.split(':')[0]) : '';
            

        return sHour + ':' + sMinutes + ' ' + sMedirian + ' to ' + eHour + ':' + eMinutes + ' ' + eMedirian;
      }

    };

    return CalendarService;

}]);